module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "kInfo1",
    attrs: {
      "model": _vm.kInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid"
    },
    model: {
      value: (_vm.kInfo1.guid),
      callback: function($$v) {
        _vm.kInfo1.guid = $$v
      },
      expression: "kInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题,60字以内"
    },
    model: {
      value: (_vm.kInfo1.title),
      callback: function($$v) {
        _vm.kInfo1.title = $$v
      },
      expression: "kInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "类型,60字以内"
    },
    model: {
      value: (_vm.kInfo1.type),
      callback: function($$v) {
        _vm.kInfo1.type = $$v
      },
      expression: "kInfo1.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原作者GUID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者GUID,如果没有，需填入0"
    },
    model: {
      value: (_vm.kInfo1.author2Guid),
      callback: function($$v) {
        _vm.kInfo1.author2Guid = $$v
      },
      expression: "kInfo1.author2Guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.keyword2),
      callback: function($$v) {
        _vm.kInfo1.keyword2 = $$v
      },
      expression: "kInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.description),
      callback: function($$v) {
        _vm.kInfo1.description = $$v
      },
      expression: "kInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveKnowledge
    }
  }, [_vm._v("保存知识点")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("知识点内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container_zsd"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 200px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6948f73c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledgeDlg/src/main.vue
// module id = 504
// module chunks = 2 5